import { render, staticRenderFns } from "./SwiperAddons.vue?vue&type=template&id=9e5c1c5e"
import script from "./SwiperAddons.vue?vue&type=script&lang=js"
export * from "./SwiperAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports